var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedApt0)",
    d: "m15.93 9.763l-7.87 2.794a.584.584 0 0 1-.776-.651l.73-3.96a.57.57 0 0 1 .205-.347l3.411-2.752a.59.59 0 0 1 .742 0L15.8 7.611a.6.6 0 0 1 .202.309l.3 1.144a.586.586 0 0 1-.373.699m-9.095 4.753l-.394 2.005a.575.575 0 0 0 .304.63a11.6 11.6 0 0 0 5.26 1.277c1.006 0 3-.132 5.206-1.25a.65.65 0 0 0 .347-.708l-.942-5.014a.587.587 0 0 0-.78-.442L7.22 14.08a.59.59 0 0 0-.386.437"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedApt0",
    x1: 17.503,
    x2: 10.354,
    y1: 18.351,
    y2: 5.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C65CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#BA6BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9991FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#42F0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3FC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApt);
export default __webpack_public_path__ + "static/media/apt.2e61f2fe1daeb486568fe7a90154e668.svg";
export { ForwardRef as ReactComponent };